import { ActivityFn, CustomPropsFn } from "single-spa";
import { MFEConfigs, RegisterableApplication } from "../models/Models";

export const determineActiveWhen =
  (app: RegisterableApplication) =>
  (location: Location): boolean => {
    let isActiveForRoute: boolean = false;
    (app.activeWhen as any).forEach((activityFn: ActivityFn) => {
      const shouldShow: boolean = activityFn(location);
      if (shouldShow) {
        // if any of the activity Functions resolve to true then it should be shown for current URL
        isActiveForRoute = true;
      }
    });
    return isActiveForRoute;
  };

export const determineCustomProps =
  (app: RegisterableApplication, mfeConfigs: MFEConfigs) =>
  (mfeName: string, location: Location) => {
    const appName: string = mfeName.replace("@cheshire-datasystems/", "");
    const propsFromRouterLayout = (app.customProps as CustomPropsFn)(
      mfeName,
      location
    );
    return {
      mfeConfigs: mfeConfigs[appName],
      shared_structures: mfeConfigs.baseconfig.shared_structures,
      shared_global_config: mfeConfigs.baseconfig.shared_global_config,
      propsFromRouterLayout: () =>
        (app.customProps as CustomPropsFn)(mfeName, location),
    };
  };

export const importModule =
  (name: string): any =>
  () =>
    System.import(name);
